import { render, staticRenderFns } from "./TalentMatrix.vue?vue&type=template&id=77b817ed"
import script from "./TalentMatrix.vue?vue&type=script&lang=js"
export * from "./TalentMatrix.vue?vue&type=script&lang=js"
import style0 from "./TalentMatrix.vue?vue&type=style&index=0&id=77b817ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports